module.exports = __webpack_public_path__ + "static/media/stakeDark.a07e7ec0.svg";